export const TICK = 0;
export const TRANSITIONTIME = 800;
export const TRANSITIONTIME_MED = 600;
export const TRANSITIONTIME_MED_SHORT = 400;
export const TT_SHORT = 200;
